import { render, staticRenderFns } from "./StoreInfoPic.vue?vue&type=template&id=66577b06&scoped=true"
import script from "./StoreInfoPic.vue?vue&type=script&lang=js"
export * from "./StoreInfoPic.vue?vue&type=script&lang=js"
import style0 from "./StoreInfoPic.vue?vue&type=style&index=0&id=66577b06&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66577b06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66577b06')) {
      api.createRecord('66577b06', component.options)
    } else {
      api.reload('66577b06', component.options)
    }
    module.hot.accept("./StoreInfoPic.vue?vue&type=template&id=66577b06&scoped=true", function () {
      api.rerender('66577b06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/storeDetails/components/StoreInfoPic.vue"
export default component.exports